import { render, staticRenderFns } from "./PromotionDetails.vue?vue&type=template&id=22d237da&scoped=true&"
import script from "./PromotionDetails.vue?vue&type=script&lang=js&"
export * from "./PromotionDetails.vue?vue&type=script&lang=js&"
import style0 from "./PromotionDetails.vue?vue&type=style&index=0&id=22d237da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d237da",
  null
  
)

export default component.exports